import { ArrowsInSimple, ArrowsOutSimple } from "@phosphor-icons/react"

import { IconButton } from "~/components/reusable/Button"
import { Tooltip } from "~/components/reusable/Tooltip"
import { useInspectorContext } from "~/components/design-system/pages/internal/InspectorContext"

/**
 * Toggles a drilldown's extra content by widening and narrowing the inspector. Rendered only for a
 * level that declared `expandableAt`, and only when the inspector can reach both sides of that
 * threshold, so it never dead-ends.
 *
 * Expanding is transient: collapsing restores the user's width, unless they dragged the seam while
 * expanded or had already dragged past the threshold. Content keys off the resulting width
 * (`useInspectorWidth`), so the icon reflects how wide the inspector IS.
 */
const InspectorExpandButton = ({ className }: { className?: string }) => {
  const { isExpanded, toggleExpanded } = useInspectorContext()

  return (
    <Tooltip title={isExpanded ? "Show less detail" : "Show more detail"}>
      <IconButton
        size="xs"
        variant="transparent"
        aria-label={isExpanded ? "Show less detail" : "Show more detail"}
        aria-expanded={isExpanded}
        className={className}
        onClick={toggleExpanded}
      >
        {isExpanded ? (
          <ArrowsInSimple className="size-4" />
        ) : (
          <ArrowsOutSimple className="size-4" />
        )}
      </IconButton>
    </Tooltip>
  )
}

export default InspectorExpandButton
